import { render, staticRenderFns } from "./SHMDescriptionViz.vue?vue&type=template&id=70f63b30&scoped=true"
import script from "./SHMDescriptionViz.vue?vue&type=script&lang=js"
export * from "./SHMDescriptionViz.vue?vue&type=script&lang=js"
import style0 from "./SHMDescriptionViz.vue?vue&type=style&index=0&id=70f63b30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f63b30",
  null
  
)

export default component.exports